import { useCallback, useMemo } from "react";

import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { useComparator } from "@tudigo-monorepo/web-tudigo-comparator";
import { useAnalytics } from "@tudigo-monorepo/web-tudigo-tracking";

export function useProjectsComparatorCustomerTracking() {
  const analytics = useAnalytics();
  const {
    config: { defaultSimulatorAmount },
    selection,
    selectionCount,
    urlState,
  } = useComparator<Project>();

  const comparatorStatePayload = useMemo(() => {
    return {
      projects_count: selectionCount,
      projects_selected_list_id: selection.map((project) => project.id),
      projects_selected_list_name: selection.map(
        (project) => project.content?.name,
      ),
      comparator_amount: urlState.amount ?? defaultSimulatorAmount,
    };
  }, [selectionCount, selection, urlState, defaultSimulatorAmount]);

  const track = analytics.track;

  const customerTrackComparator = useCallback(
    (eventName: string, payload?: Record<string, unknown>) => {
      console.log(
        `[CUSTOMER] Tracking Projects Comparator event "${eventName}" with payload: ${JSON.stringify(
          payload,
          null,
          2,
        )}`,
      );

      return track(eventName, payload);
    },
    [track],
  );

  return { comparatorStatePayload, customerTrackComparator };
}
